import { z } from 'zod';

export const uuidSchema = z.string().uuid();

export const paginationSchema = z.object({
  limit: z.coerce.number().int().min(1).max(100).default(50),
  offset: z.coerce.number().int().min(0).default(0),
});

export const timestampSchema = z.string().datetime();

export const idParamSchema = z.object({
  id: uuidSchema,
});

// =============================================================================
// UTILITY TYPES
// =============================================================================

/** Generic JSON-compatible value (replaces the old Supabase-generated Json type) */
export type Json = string | number | boolean | null | { [key: string]: Json | undefined } | Json[];

// =============================================================================
// RESPONSE TYPE WRAPPERS
// =============================================================================

export interface ApiErrorResponse {
  error: string;
  message: string;
  details?: Record<string, unknown>;
}

export interface ApiDataResponse<T> {
  data: T;
}

export interface ApiListResponse<T> {
  data: T[];
}

export interface ApiSuccessResponse {
  success: true;
}
